var opacity = {
    init: function() {
        opacity.wrapper();
        opacity.header();
    },

    wrapper: function() {
        $('.wrapper').stop().animate({
            opacity: 1
        }, 400);
    },

    header: function() {
        $('.header').stop().animate({
            opacity: 1
        }, 400);
    }
}

$(opacity.init)